import React, { BaseSyntheticEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import usePost from 'src/hooks/usePost';
import Page from 'src/layout/Page';
import './login.css';
import { useTranslation } from 'react-i18next';

const Login: React.FC = (): React.ReactElement => {
  const [isValid, setIsValid] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const formRef = React.useRef() as React.MutableRefObject<HTMLFormElement>;
  const { makeRequest, error, invalidateError } = usePost();
  const { setAuthToken, setAuthUser } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
			if (i18n.language !== 'en') {
				navigate('/התחברות');
			} else {
				navigate('/en/personal');
			}
    }
  }, []);

  useEffect(() => {
    document.title = t('pages.login.title');
  }, [i18n.language]);

  const handleLogin = async (e: BaseSyntheticEvent) => {
    invalidateError();
    e.preventDefault();
    const payload = Object.fromEntries(new FormData(formRef.current));

    if (formRef.current?.checkValidity()) {
      const data = await makeRequest('auth/signin', false, { ...payload });
      if (!data.error && data.success !== false) {
        const { accessToken, user } = data;
        setAuthToken(accessToken);
        setAuthUser(JSON.stringify(user));
				if (i18n.language !== 'en') {
					navigate('/התחברות');
				} else {
					navigate('/en/personal');
				}
      }
    }
  };

  const handleSignUp = (e: BaseSyntheticEvent) => {
    e.preventDefault();
		if (i18n.language !== 'en') {
			navigate('/הרשמה');
		} else {
			navigate('/en/sign-up');
		}
  };

  const checkValidity = () => {
    invalidateError();
    if (formRef.current.checkValidity()) {
      setIsValid(true);
      return true;
    }
    setIsValid(false);
    return false;
  };

  return (
    <Page pageClass={'login-page'} pageHeader={t('pages.login.title')}>
      <form className={'login-form'} ref={formRef}>
        <input
          name="email"
          type="email"
          placeholder={t('pages.login.email')}
          required
          onInput={checkValidity}
        />
        <input
          name="password"
          type="password"
          placeholder={t('pages.login.password')}
          required
          onInput={checkValidity}
        />
        <button
          className={'scroll-to-button active'}
          type="submit"
          onClick={handleLogin}
          disabled={!isValid}
          data-disabled={!isValid}
        >
          {t('pages.login.login')}
        </button>
        <button
          type="submit"
          className={'scroll-to-button'}
          name={'sign-up'}
          onClick={handleSignUp}
        >
          {t('pages.login.signup')}
        </button>
        {error && <div className={'error'}>{t(`errors.${error.errorCode}`)}</div>}
      </form>
    </Page>
  );
};

export default Login;
